module.exports = __webpack_public_path__ + "static/media/miniClass.d01c2ea1.png";